import { MenuOpenOutlined } from "@mui/icons-material"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import AccordionGroup, { AccordionRow } from "@components/accordion_group"
import LeftDrawer from "@components/persist_drawer"
import SectionBar from "@components/section_bar"
import { PRIMARY } from "@constants/colors"
import { useCouponsPageContext } from "@contexts/main/coupons_page_context"
import { useScriptsPageContext } from "@contexts/main/scripts_page_context"
import { useNavigate } from "react-router-dom"

export default function ScriptsPageLeftDrawer() {
  const { isLeftDrawerOpen, toggleIsLeftDrawerOpen, translate } =
    useScriptsPageContext()

  const [selectedValue, setSelectedValue] = useState("all")
  const navigate = useNavigate()

  const data: {
    title: string
    rowList: AccordionRow[]
    rightIconGroup?: React.ReactNode
    isDefaultOpen: boolean
  }[] = [
    {
      title: translate("status"),
      rowList: [
        {
          label: "All",
          value: "/scripts"
        },
        {
          label: "Message Test",
          value: "message-test"
        },
        {
          label: "Migrations",
          value: "migrations"
        }
      ],
      isDefaultOpen: true
    }
  ]

  return (
    <LeftDrawer
      isOpen={!!isLeftDrawerOpen}
      header={<Header setClose={toggleIsLeftDrawerOpen} />}
      sx={{
        borderRight: 1,
        borderColor: "divider",
        width: "16rem",
        minWidth: "16rem",
        maxWidth: "16rem"
      }}
    >
      <AccordionGroup
        accordionList={data}
        selectedValue={selectedValue}
        onClick={(value) => {
          navigate(value)
          setSelectedValue(value)
        }}
      />
    </LeftDrawer>
  )
}

function Header({ setClose }: { setClose?: () => void }) {
  const { translate } = useCouponsPageContext()

  return (
    <SectionBar
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        p: 1
      }}
    >
      <Typography p={1} variant="h6">
        {translate("scripts_tooltip")}
      </Typography>
      <IconButton
        disableRipple
        sx={{
          ":hover": {
            color: PRIMARY
          }
        }}
        onClick={setClose}
      >
        <MenuOpenOutlined />
      </IconButton>
    </SectionBar>
  )
}
